// src/utils/captureThumbnail.js
import html2canvas from 'html2canvas';

export default async function captureThumbnail(iframeEl, timeoutMs = 2000) {
    if (!iframeEl) {
      console.warn('captureThumbnail: no iframe element');
      return null;
    }
    const win = iframeEl.contentWindow;
    if (!win) {
      console.warn('captureThumbnail: no contentWindow');
      return null;
    }

    // 1) wait for both the load event and readyState === 'complete'
    await new Promise((resolve) => {
      const doc = win.document;
      if (doc.readyState === 'complete') return resolve();

      const onLoad = () => { cleanup(); resolve(); };
      const timeout = setTimeout(() => { cleanup(); resolve(); }, timeoutMs);

      function cleanup() {
        iframeEl.removeEventListener('load', onLoad);
        clearTimeout(timeout);
      }

      iframeEl.addEventListener('load', onLoad, { once: true });
    });

    const doc = win.document;
    // 2) target the root element for full-page capture
    const el = doc.documentElement;
    const w  = el.scrollWidth  || el.offsetWidth;
    const h  = el.scrollHeight || el.offsetHeight;

    console.log(`captureThumbnail: content size ${w}×${h}`);
    if (w === 0 || h === 0) {
      console.warn('captureThumbnail: zero-sized content, skipping thumbnail');
      return null;
    }

    // 3) clamp max width to 400px
    const scale = Math.min(400 / w, 1);

    try {
      const canvas = await html2canvas(el, {
        backgroundColor: null,
        useCORS:       true,
        scale,
        logging:      false,
        width:        w,
        height:       h,
        windowWidth:  w,
        windowHeight: h,
      });
      const dataUrl = canvas.toDataURL('image/png');
      return dataUrl.startsWith('data:image/png;base64,') ? dataUrl : null;
    } catch (err) {
      console.error('captureThumbnail: html2canvas failed', err);
      return null;
    }
  }
